var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35828 9C11.2913 9 12.8583 7.433 12.8583 5.5C12.8583 3.567 11.2913 2 9.35828 2C7.42528 2 5.85828 3.567 5.85828 5.5C5.85828 7.433 7.42528 9 9.35828 9ZM9.35828 11C12.3958 11 14.8583 8.53757 14.8583 5.5C14.8583 2.46243 12.3958 0 9.35828 0C6.32071 0 3.85828 2.46243 3.85828 5.5C3.85828 8.53757 6.32071 11 9.35828 11Z",
    fill: "#9D9ABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8583 17.5C15.8583 13.9101 12.9481 11 9.35828 11C5.76843 11 2.85828 13.9101 2.85828 17.5C2.85828 19 0.858276 18.9893 0.858276 17.5C0.858276 12.8056 4.66386 9 9.35828 9C14.0527 9 17.8583 12.8056 17.8583 17.5C17.8583 18.9344 15.8583 19.0356 15.8583 17.5Z",
    fill: "#9D9ABA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.966dd0d4.svg";
export { ForwardRef as ReactComponent };